import React from "react";
import SubmittedAgreement from "../sumitted_agreement/SubmittedAgreement";

const ReconsiderationRecordedAgreement = () => {
  const fileStatus = 34;
  const applicationPath = {
    copyright: "/admin/reconsideration-recorded-copyright",
    agreement: "/admin/reconsideration-recorded-agreement",
  };
  return (
    <SubmittedAgreement
      pageTitle={"নথিজাত পুনর্বিবেচনা"}
      fileStatus={fileStatus}
      applicationPath={applicationPath}
      detailsRoute={"/admin/reconsideration-agreement-details"}
    />
  );
};

export default ReconsiderationRecordedAgreement;
